import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import AlertModalActions from '../../redux/actions/A_Alert_Modal';
import { exclamationMarkSVG } from '../../Images/AlertsSVG';
import { AgentButton } from 'global-components-library';

Modal.setAppElement('body');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    bottom: 'auto',
    width: '404px',
    height: 'auto',
    overflow: 'hidden',
    padding: '0',
    transform: 'translate(-50%, -50%)'
  }
};

export const AlertModal = (props) => {
  const {
    isModalOpen,
    hideAlertModal,
    data
  } = props;

  const {
    type, message, boldMessage, title, button, buttonFun, secondButton, secondButtonFtn, timeout, timeoutFun
  } = data;

  const reloadPage = () => {
    hideAlertModal();
    if (buttonFun) {
      buttonFun();
    }
  }

  const secondBut = () => {
    hideAlertModal();
    if (secondButtonFtn) {
      secondButtonFtn();
    }
  }

  const onTimeout = () => {
    hideAlertModal();
    if (timeoutFun) {
      timeoutFun();
    }
  }

  const timeoutID = useRef()
  useEffect(() => {
    if(timeout != null && timeout > 0){
      timeoutID.current = setTimeout(onTimeout, timeout);
    }
    return () => { clearTimeout(timeoutID.current); }
  }, [timeout])
  

  return (
    <Modal
      isOpen={isModalOpen}
      style={customStyles}>
      <div className="AlertModalHeader">
        <div className={`AlertModalIcon ${type}`}>{exclamationMarkSVG}</div>
        <span className={`AlertModalHeaderLabel`}>{title}</span>
      </div>
      <div className="AlertModalBody">
        <p className="AlertModalInformation">{`${message} `}<strong>{boldMessage}</strong>
        </p>
      </div>
      <div className="AlertModalFooter">
        <div className='btn-confirmation-modal'><AgentButton type='tertiary' onClick={reloadPage}>{button}</AgentButton></div>
        {secondButton && <div className='btn-confirmation-modal'> <AgentButton type='primary' color={'blue'} onClick={secondBut}>{secondButton}</AgentButton></div>}
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  const { isModalOpen, data } = state.isAlertModalOpen;

  return {
    isModalOpen,
    data,
  };
};

const mapDispatchToProps = (dispatch) => {
  const { hideAlertModal } = AlertModalActions.creators;

  return bindActionCreators({
    hideAlertModal,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertModal);


// WEBPACK FOOTER //
// ./src/components/Alerts/AlertModal.jsx